module.exports = __webpack_public_path__ + "assets/img/16e1-fj.svg";